import React  from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { LinkProviderService } from "./service/LinkProviderService";

export const AppTopbar = (props) => {


    const linkService = new LinkProviderService();

    return (
        <div >     
                   <div class="regular-display-topbar" id="navigation-cgos-toolbar">
                   <nav class="nav-cgos-toolbar" style={{width: "1170px"}}>
                   <h1><img src="https://cdn.cgos.info/cgosBar/img/logoCGOSNB.png" /></h1>
                   <ul class="left-cgos">
                   <li class="accueil">
                   <a href="//www.cgos.info" style={{padding:0,paddingLeft:"20px",paddingRight:"20px"}} title="AccÃ©der au portail C.G.O.S">
                   <img src="https://cdn.cgos.info/cgosBar/img/logoCGOS.png" alt="Logo du C.G.O.S" style={{paddingTop:"5px",paddingBottom:"6px",height:"50px"}}/>
                   </a>
                   </li>
                   <li class="famille">
                   <a href="//www.cgos.info/3/notre-action-sociale/vous-et-votre-famille/" title="Vos prestations sociales avec le C.G.O.S">
                   <span>Prestations sociales</span></a></li><li class="cgosetvous">
                   <a href="//cgosetvous.cgos.info/" title="Vacances, Billetterie, Loisirs, Avantages-conso et Services+ avec le C.G.O.S">
                   <span>Le C.G.O.S &amp; Vous</span></a></li><li class="retraite"><a href="//crh.cgos.info/" target="_blank">
                   <span title="Votre ComplÃ©mentaire Retraite des Hospitaliers">CRH</span></a></li>
                
                   </ul>
                   <h1>
                       <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOsAAAAyCAYAAAC9OywyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkU4RjRCNzEzODk4QzExRTNCQTAzQ0VFODg4NEZEMjM1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkU4RjRCNzE0ODk4QzExRTNCQTAzQ0VFODg4NEZEMjM1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RThGNEI3MTE4OThDMTFFM0JBMDNDRUU4ODg0RkQyMzUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RThGNEI3MTI4OThDMTFFM0JBMDNDRUU4ODg0RkQyMzUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6RKmCeAAAA4UlEQVR42uzYwQmDMBSA4dpR7AidoavUmZyhI9gVukJXiSl4Ej0Iz5CG74N3CbwchB/FLqV0AerXiRXECogVxAqIFRAriBUQKyBWECsgVkCsIFZArIBYQayAWAGxglgBsYJYAbECYgWxAmIFjrl6BFV55knLTHn6wvtRd+DN2nyo4+rsm+dWaD/qDrxZm3ffOOt3zs/Yj7oDsYJYqcN74+z3CfoptB91B2Jt3ivPsArnUXA/6g5O4gcTiBUQK4gVECsgVhArIFZArCBWQKyAWEGsgFgBsYJYAbECYoV/MQswAGxRpXq7ydgeAAAAAElFTkSuQmCC"/>
                       </h1>
                    <ul class="right-cgos">
                           <li class="faq">
                           <a href="https://www.cgos.info/17/nous-contacter/faq/prestations" style={{paddingLeft:"40px",height: "40px"}}>
                               <i title="Foire aux questions">&nbsp;</i><span title="Foire aux questions" style={{display: "inline"}}>FAQ</span></a>
                               </li><li class="contact">
                                   <a href="https://www.cgos.info/4/nous-contacter/" style={{paddingLeft:"40px", height: "40px"}}>
                                       <i title="Contacter le C.G.O.S">&nbsp;</i>
                                       <span title="Contacter le C.G.O.S" style={{display: "inline"}}>Nous contacter</span></a></li>
                                       <li class="agent active"><a href="https://agent.cgos.info/nous-contacter " style={{paddingLeft:"40px",height: "40px"}} title="AccÃ©der Ã&nbsp; votre Espace Agent">
                                           <i title="AccÃ©der Ã&nbsp; votre Espace Agent">
                   &nbsp;</i><span style={{display: "inline"}}>Espace Agent</span></a></li>
                   </ul><div class="mobile-modif-dept"></div></nav>
                   </div>

                   <div class="blueBlock_Barre">
                      <div class="espaceAgentTitle"> <span class="eaTextTop">Espace Agent</span>

                      <div class="a-barrebleu-ea">
                          <ul>
                            <li>
                                <a href="https://agent.cgos.info/agent/ctrl/servirFichierAideLogin" onclick="pageCheckChange(true);return true;" target="_blank">
                                    <i class="fa fa-desktop"></i>
                                    <b><span>AIDE</span></b>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.cgos.info/17/nous-contacter/faq/espace-agent"><i class="fa fa-question-circle"></i>
                                <b><span>FAQ</span></b>
                                </a>
                            </li>
                          </ul>
                      </div>
                      </div>
                    </div>

                   <div id="mobile-header-cgos-toolbar">
                       <a id="responsive-menu-button-cgos-toolbar" href={linkService.getRetourEaMembrePrestation()}>
                           <img src="https://cdn.cgos.info/cgosBar/img/logoCGOS-ICON.png" style={{width:"40px",padding:"5px"}}/></a>
                    </div>

                
        </div>
    );
}
